export const serviceTutorialSteps = [
  {
    target: '#service-hero',
    title: 'Centro comercial de servicios',
    content: 'Desde acá armás pedidos, definís recorridos, aplicás acuerdos comerciales y decidís cuándo pasar el trabajo a logística.',
    narration: 'Desde acá armás pedidos, definís recorridos, aplicás acuerdos comerciales y decidís cuándo pasar el trabajo a logística.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#service-summary',
    title: 'Resumen rápido',
    content: 'Estas métricas te muestran clientes listos, pendientes, facturado y contratos activos para leer el estado comercial del día en segundos.',
    narration: 'Estas métricas te muestran clientes listos, pendientes, facturado y contratos activos para leer el estado comercial del día en segundos.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#service-tabs',
    title: 'Secciones del módulo',
    content: 'Acá cambiás entre servicios vivos, programados, clientes, contratos, cierres, calendario y referencias de mercado sin salir del módulo.',
    narration: 'Acá cambiás entre servicios vivos, programados, clientes, contratos, cierres, calendario y referencias de mercado sin salir del módulo.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#service-panel',
    title: 'Panel activo',
    content: 'El panel central muestra el detalle de la sección elegida. En servicios ves lo operativo, en contratos definís acuerdos y en cierres controlás lo pendiente de cobrar.',
    narration: 'El panel central muestra el detalle de la sección elegida. En servicios ves lo operativo, en contratos definís acuerdos y en cierres controlás lo pendiente de cobrar.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '#service-active-filters',
    title: 'Activos, revisión y archivados',
    content: 'Desde acá separás lo que sigue vivo, lo que necesita revisión y lo que ya quedó archivado para mantener la operación más limpia.',
    narration: 'Desde acá separás lo que sigue vivo, lo que necesita revisión y lo que ya quedó archivado para mantener la operación más limpia.',
    placement: 'bottom',
    disableBeacon: true,
  },
];

export default serviceTutorialSteps;
